const Theme = {
  body_background_color: '#95ADBB',
  header_background_color: '#F1BF00',
  header_border_color: '#F1BF00',

  logo_image_url: 'lesaisonnier.png',
  logo_height: 140,

  number_font: `'Arvo', sans-serif`,
  number_weight: 400,

  button_color: '#A7AA00',
  button_font: `'Open Sans', sans-serif`,
  button_text_lineheight: 25,
  button_text_size: 15,
  button_radius: 15,
  button_text_weight: 600,

  title_font: `'Arvo', sans-serif`,
  title_size: 36,
  title_lineheight: 42,
  title_weight: 400,

  subtitle_size: 24,
  subtitle_lineheight: 31.8,

  text_font: `'Open Sans', sans-serif`,
  text_color: '#1a1c1d',
  text_size: 15,
  text_lineheight: 25,

  separator_color: '#95ADBB',

  footer_text_color: '#1a1c1d',
}

export default Theme
